import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { HttpService } from '../../services/HttpService';
import Store from '..';


export const initialState = {
  list: [],
  listCalendar: [],
  countListAll: 0,
  dateFilter: [],
  search: {
    date: "",
    timeslotFilter: "",
    eventId: "",
    searchInput: "",
    timeslotCategory: "",
  },
  page: 1,
  order: "timeslot.startDate",
  orderAs: "desc",
  timeslotFilter: [],
}

const numberpage = process.env.REACT_APP_PAGE_LIST ?? 10;


export const loadListCalendar = () => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (eventId) {
      // const result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/dateattendance`);
      // dispacth(updateListCalendar(result.data.result))
    }

  }
  catch (e: any) {
    console.log("Load CategoryTimeslot", e);
    return e.response;
  }
}
export const editTimeslotByBookingId = (timeslotbookingId: any, timeslotId: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (timeslotbookingId) {
      const result = await HttpService.put(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/bookingid/${timeslotbookingId}`, { timeslotId: timeslotId });
      // const result2 = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/dateattendance`);
      // await dispacth(updateListCalendar(result2.data.result))
      // await dispacth(loadPrenotationList());
      return result
    }

  }
  catch (e: any) {
    console.log("Delete Timeslot By BookingId", e);
    return e.response;
  }
}


export const deleteTimeslotByBookingId = (timeslotbookingId: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    if (timeslotbookingId) {
      const result = await HttpService.delete(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/bookingid/${timeslotbookingId}`);
      // await dispacth(loadListCalendar());
      // await dispacth(loadPrenotationList());
      return result
    }

  }
  catch (e: any) {
    console.log("Delete Timeslot By BookingId", e);
    return e.response;
  }
}



export const loadPrenotationList = () => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const orderAs = Store.getState().prenotation.orderAs;
    const order = Store.getState().prenotation.order;
    const search = Store.getState().prenotation.search;
    const page = Store.getState().prenotation.page;
    const response = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/attendance/event/${eventId}/paginated?page=${page}&itemsPerPage=${numberpage}&search=${search.searchInput}&orderBy=${order}&orderAs=${orderAs}&dateTimeslot=${search.date}&timeslotId=${search.timeslotFilter}&category=${search.timeslotCategory}`);
    dispacth(updateList(response.data.result));

    const responseCountList = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/attendance/event/${eventId}/attendancescount?search=${search.searchInput}&orderBy=${order}&orderAs=${orderAs}&dateTimeslot=${search.date}&timeslotId=${search.timeslotFilter}&category=${search.timeslotCategory}`);
    dispacth(updateCoutListAll(responseCountList.data.count));

  }
  catch (e) {
    console.log(e)
  }

}

export const loadDatesWithTimeslot = () => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const responseDateFilter = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/date`);
    dispacth(updateDateFilter(responseDateFilter.data.result));
  }
  catch (e) {
    console.log('loadDateWithTimeslot', e)
  }

}

export const loadFilterPrenotations = (date: any, timeslotCategory: any) => async (dispacth: any) => {
  try {
    const eventId = Store.getState().login.eventId;
    const responseTimeslotFilter = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/day/${date}?category=${timeslotCategory}`);
    dispacth(updateTimeslotFilter(responseTimeslotFilter.data.result));
  }
  catch (e) {
    console.log(e)
  }

}

export const deletePrenotationStore = (id: string) => async (dispacth: any) => {
  try {
    let search: any = Store.getState().prenotation.search;
    if (search.eventId) {
      let params = {
        data: [id]
      };
      await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/attendance/delete`, params);
      dispacth(loadPrenotationList())
      // const responseDateFilter = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${search.eventId}/timeslot/date`);
      // dispacth(updateDateFilter(responseDateFilter.data.result));
      // if (search.date) {
      //   const responseTimeslotFilter = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${search.eventId}/timeslot/day/${search.date}`);
      //   dispacth(updateTimeslotFilter(responseTimeslotFilter.data.result));
      // }
      // // dispacth(loadListCalendar());
      // dispacth(updateSearch(search));
    }
  }
  catch (e) {
    console.log("Change Page", e);
    return e
  }
}

const prenotationReducer = createSlice({
  name: 'Prenotation',
  initialState,
  reducers: {
    deleteList(state) {
      state.list = [];
    },
    updateList(state, action: PayloadAction<any>) {
      state.list = action.payload;
    },
    updateDateFilter(state, action: PayloadAction<any>) {
      state.dateFilter = action.payload
    },
    updateSearch(state, action: PayloadAction<any>) {
      state.search = action.payload
    },
    updateCoutListAll(state, action: PayloadAction<any>) {
      state.countListAll = action.payload ?? 1
    },
    updateTimeslotFilter(state, action: PayloadAction<any>) {
      state.timeslotFilter = action.payload
    },
    updateListCalendar(state, action: PayloadAction<any>) {
      state.listCalendar = action.payload
    },
    updateOrder(state, action: PayloadAction<any>) {
      state.order = action.payload
    },
    updateOrderAs(state, action: PayloadAction<any>) {
      state.orderAs = action.payload
    },
    updatePage(state, action: PayloadAction<any>) {
      state.page = action.payload
    },

  }

})


export const { deleteList, updateListCalendar, updateList, updateSearch, updateCoutListAll, updateDateFilter, updateTimeslotFilter, updateOrder, updateOrderAs, updatePage } = prenotationReducer.actions
export default prenotationReducer.reducer
